import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { CreateResult } from "../models/create-result";
import {CommsProfileParticipantLinkViewModel} from "../models/comms-profile-participant-link";

@Injectable({
  providedIn: 'root'
})
export class CommsProfileService {

  constructor(private _httpService: HttpService) {
  }

  public async GetCommsProfileByParticipant(participantId: number): Promise<CommsProfileParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CommsProfileParticipantLinkViewModel[]>(`commsProfile/GetCommsProfileByParticipant/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async DeleteCommsProfileByParticipantId(participantId: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`commsProfile/DeleteCommsProfile/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async UpdateCommsProfiles(cardSets: CommsProfileParticipantLinkViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`commsProfile/UpdateCommsProfiles`, cardSets);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetCommsProfilesForParticipantOrAll(): Promise<CommsProfileParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CommsProfileParticipantLinkViewModel[]>(`commsProfile/CommsProfilesForParticipantOrAll`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetCommsProfilesByParticipant(participantId: number): Promise<CommsProfileParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CommsProfileParticipantLinkViewModel[]>(`commsProfile/CommsProfilesByParticipant/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetCommsProfiles(): Promise<CommsProfileParticipantLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<CommsProfileParticipantLinkViewModel[]>(`commsProfile/CommsProfiles`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
}
